import React from 'react';
import SectionContainer from '../../../common/SectionContainer';
import { formatCurrency } from '../../../common/formatUtils';
import { rtreFormulas } from '../formulas';

const RTRESection = ({ data, computed }) => {
  const remanente = rtreFormulas.remanente(data);
  const reverso = rtreFormulas.reversoRAI(data);
  const raiEj = rtreFormulas.raiEjercicio(data);
  const rex = rtreFormulas.rexPercibidos(data);
  const credRLI = rtreFormulas.creditoIDPCSobreRLI(data);
  const credDiv = rtreFormulas.creditoIDPCSobreDividendo(data);
  const subtotal = computed.rtre?.subtotalAntes || {};
  const remSig = computed.rtre?.remanenteSiguiente || {};
  const imputaciones = rtreFormulas.imputacionesRetiros(data);

  const columns = [
    { key: 'detalle', label: 'Detalle', flex: 3 },
    { key: 'control', label: 'Control' },
    { key: 'RAI', label: 'RAI' },
    { key: 'REX_RAP', label: 'REX RAP' },
    { key: 'REX_INR', label: 'INR' },
    { key: 'SAC_noSujetoSinDev', label: 'SAC NoSuj S/Dev' },
    { key: 'SAC_noSujetoConDev', label: 'SAC NoSuj C/Dev' },
    { key: 'SAC_sujetoConDev', label: 'SAC Suj C/Dev' },
    { key: 'SAC_IPE_sinDev', label: 'SAC IPE' },
    { key: 'SAC_2016_conDev', label: 'SAC 2016' },
    { key: 'STUT', label: 'STUT' },
  ];

  const makeRow = (detalle, values) => ({
    detalle,
    control: formatCurrency(values.control),
    RAI: formatCurrency(values.RAI),
    REX_RAP: formatCurrency(values.REX_RAP),
    REX_INR: formatCurrency(values.REX_INR),
    SAC_noSujetoSinDev: formatCurrency(values.SAC_noSujetoSinDev),
    SAC_noSujetoConDev: formatCurrency(values.SAC_noSujetoConDev),
    SAC_sujetoConDev: formatCurrency(values.SAC_sujetoConDev),
    SAC_IPE_sinDev: formatCurrency(values.SAC_IPE_sinDev),
    SAC_2016_conDev: formatCurrency(values.SAC_2016_conDev),
    STUT: formatCurrency(values.STUT),
  });

  const rows = [
    makeRow('Remanente ejercicio anterior', remanente),
    makeRow('(-) Reverso RAI', { ...emptyRow(), ...reverso }),
    makeRow('(+) RAI del ejercicio', { ...emptyRow(), ...raiEj }),
    makeRow('(+) REX percibidos', { ...emptyRow(), ...rex }),
    makeRow('(+) Crédito IDPC sobre RLI', { ...emptyRow(), ...credRLI }),
    makeRow('(+) Crédito IDPC sobre dividendo', { ...emptyRow(), ...credDiv }),
    makeRow('Subtotal antes de imputaciones', subtotal),
  ];

  // Agregar una fila por cada retiro individual con prorrateo RAI/REX
  imputaciones.forEach((imp) => {
    const label = `(-) Retiro ${imp.nombre || ''}${imp.fechaRetiro ? ` (${imp.fechaRetiro})` : ''}`;
    rows.push(makeRow(label, { ...emptyRow(), ...imp }));
  });

  // Crédito gastos rechazados
  const cGR = rtreFormulas.creditoGastosRechazados(data);
  rows.push(makeRow('(-) Crédito IDPC gastos rechazados', { ...emptyRow(), ...cGR }));

  // Remanente siguiente
  rows.push(makeRow('Remanente ejercicio siguiente', remSig));

  return (
    <SectionContainer title="RTRE" subtitle="Registro Tributario de Rentas Empresariales al 31.12.2025">
      <div className="f22-rtre-table-wrapper">
        <div className="f22-rtre-table">
          <div className="f22-rtre-header">
            {columns.map((col) => (
              <div key={col.key} className="f22-rtre-cell f22-rtre-header-cell" style={{ flex: col.flex || 1 }}>
                {col.label}
              </div>
            ))}
          </div>
          {rows.map((row, i) => {
            const isTotal = row.detalle.includes('Subtotal') || row.detalle.includes('Remanente ejercicio siguiente');
            return (
              <div key={i} className={`f22-rtre-row ${isTotal ? 'f22-rtre-total' : ''}`}>
                {columns.map((col) => (
                  <div key={col.key} className="f22-rtre-cell" style={{ flex: col.flex || 1 }}>
                    {row[col.key]}
                  </div>
                ))}
              </div>
            );
          })}
        </div>
      </div>
    </SectionContainer>
  );
};

const emptyRow = () => ({
  control: 0, RAI: 0, REX_RAP: 0, REX_INR: 0,
  SAC_noSujetoSinDev: 0, SAC_noSujetoConDev: 0, SAC_sujetoConDev: 0,
  SAC_IPE_sinDev: 0, SAC_2016_conDev: 0, STUT: 0,
});

export default RTRESection;
